import StepperItem from './StepperItem';

export default StepperItem;


// WEBPACK FOOTER //
// /src/components/intro/pages/about/stepper/stepperItem/index.js